import { render, staticRenderFns } from "./unload-content-welcome.vue?vue&type=template&id=8d63b580"
var script = {}
import style0 from "./unload-content-welcome.vue?vue&type=style&index=0&id=8d63b580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports